<div class="row text-black">
  @if (selectedQuestion) {
    <div class="col-lg-3 col-md-4">
      @for (question of faqs; track question) {
        <div
          class="py-3 font-size-smaller"
          [class.text-primary]="selectedQuestion.id == question.id"
        >
          <span class="cursor-pointer" (click)="selectQuestion(question)">
            {{ question.title }}
            @if (selectedQuestion.id == question.id) {
              <i class="pl-3 fa fa-angle-right"></i>
            }
          </span>
        </div>
      }
    </div>
  }
  <div class="col-lg-9 col-md-8">
    <div class="answer">
      <div class="font-weight-extrabold question pb-3">
        {{ selectedQuestion.title }}
      </div>
      @if (selectedQuestion) {
        <div class="ck-content" [innerHTML]="selectedQuestion.description | trustSrc"></div>
      }
    </div>
  </div>
</div>
